/*-----------------------------------------------------------------*/
/*	自動生成クーポンIDをコピーし、コピーしたよアニメを発火させる	 */
/*-----------------------------------------------------------------*/
$(function(){
	$("body").append("<div id='autogenerate_id_copied_tooltip'>コピーしました</div>");

	$(".autogenerate_id_copy").click(function(){

		navigator.clipboard.writeText($(this).data('autogenerate_id'));

		var offset = $(this).offset();

		$("#autogenerate_id_copied_tooltip").css('top',(offset.top-10)+"px");
		$("#autogenerate_id_copied_tooltip").css('left',(offset.left+20)+"px");
		$("#autogenerate_id_copied_tooltip").addClass('visible');

		setTimeout(function(){
			$("#autogenerate_id_copied_tooltip").removeClass("visible");
		},2000);

		
	});
});
